"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { NewButton } from "@/components/ui/NewButton";

const PAGES_SINGLE_BOOK_DEMO = [
  "/solutions/safety-communication-system",
  "/solutions/multi-channel-employee-communication-platform",
];

const ON_PREMISE_PATH = "/solutions/on-premise-digital-signage";

export function MobileStickyCTA() {
  const [hideCta, setHideCta] = useState(false);
  const [showAfterScroll, setShowAfterScroll] = useState(false);
  const pathname = usePathname();

  const singleBookDemo = pathname ? PAGES_SINGLE_BOOK_DEMO.includes(pathname) : false;
  const isOnPremisePage = pathname === ON_PREMISE_PATH;

  useEffect(() => {
    const sentinel = document.getElementById("footer-cta-sentinel");
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        setHideCta(entry.isIntersecting);
      },
      {
        root: null,
        threshold: 0.01,
      }
    );

    observer.observe(sentinel);

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY || window.pageYOffset || 0;
      // Show sticky CTA only after user has scrolled past the initial hero area
      setShowAfterScroll(offset > 400);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (hideCta || !showAfterScroll) return null;

  if (singleBookDemo) {
    return (
      <div className="fixed z-10 bottom-0 border-t border-[#DDDDDD] left-0 right-0 w-full justify-center bg-white px-6 py-4 flex md:hidden">
        <Link
          href="/book-a-demo"
          className="w-full max-w-[280px]"
          data-mixpanel-id="mobile-single-book-demo-book-a-demo"
        >
          <NewButton variant="primary" size="sm" arrow="grow" className="font-xs sm:text-base w-full">
            Book a Demo
          </NewButton>
        </Link>
      </div>
    );
  }

  if (isOnPremisePage) {
    return (
      <div className="fixed z-10 bottom-0 border-t border-[#DDDDDD] left-0 right-0 w-full justify-center bg-white px-6 py-4 flex-row gap-3 flex md:hidden">
        <Link href="/book-a-demo" data-mixpanel-id="mobile-onprem-book-a-demo">
          <NewButton
            variant="primary"
            size="sm"
            arrow="grow"
            className="font-xs sm:text-base px-0 min-w-[165px]"
          >
            Book a Demo
          </NewButton>
        </Link>
        <Link href="/company/contact" data-mixpanel-id="mobile-onprem-contact-us">
          <NewButton
            variant="outlinePrimary"
            size="sm"
            className="font-xs sm:text-base px-0 w-[124px]"
          >
            Contact Us
          </NewButton>
        </Link>
      </div>
    );
  }

  return (
    <div className="fixed z-10 bottom-0 border-t border-[#DDDDDD] left-0 right-0 w-full justify-center bg-white px-6 py-4 flex md:hidden">
      <Link href="/book-a-demo" data-mixpanel-id="mobile-book-a-demo">
        <NewButton variant="primary" size="sm" arrow="grow" className="font-xs sm:text-base h-11 px-6">
          Book a Demo
        </NewButton>
      </Link>
    </div>
  );
}
